<script setup>
import { computed, ref } from 'vue';
import NoticeNoEmbed from './NoticeNoEmbed.vue';
import NoticeArticleArchived from './NoticeArticleArchived.vue';

const { currentArticle, isArticleInverted, showIframe, markAsRead } = defineProps({
	currentArticle: Object,
	isArticleInverted: Boolean,
	showIframe: Boolean,
	markAsRead: Function,
});

</script>

<template>
	<aside
		id="articleFrame"
		:class="{'no-embed': !showIframe}"
	>
		<iframe
			v-if="showIframe"
			id="iframe"
			:src="currentArticle?.privacy ?? currentArticle?.url"
			:class="{invert: isArticleInverted}"
		></iframe>

		<!-- ARCHIVED DIALOG -->
		<NoticeArticleArchived
			v-if="currentArticle && currentArticle?.archive"
			:currentArticle="currentArticle"
		></NoticeArticleArchived>

		<!-- NO-EMBED DIALOG -->
		<NoticeNoEmbed
			v-if="currentArticle && !currentArticle.embed && !currentArticle.privacy"
			:currentArticle="currentArticle"
			:markAsRead="markAsRead"
		/>
	</aside>
</template>

<style lang="scss" scoped>
#articleFrame {
	/* hidden until 1024 */
	background-color: var(--bg1);
	border-left: 1px solid var(--border);
	box-sizing: border-box;

	display: flex;
	flex-flow: column;
	align-items: center;
	justify-content: flex-start;

	flex-shrink: 0;
	position: sticky;
	top: 0;
	height: 100vh; // fallback
	height: 100dvh;
	width: calc(100vw - var(--sidebar-width) - 35vw);
	max-width: calc(100vw - var(--sidebar-width) - 35vw);

	@media(min-width:1280px) {
		width: calc(100vw - var(--sidebar-width) - 448px);
		max-width: calc(100vw - var(--sidebar-width) - 448px);
	}

	&.no-embed {
		background-image: url(/study/img/no-embed-light.png);
		background-size: 60px auto;
		background-position: calc(100% - 20px) calc(100vh - 155px); // fallback
		background-position: calc(100% - 20px) calc(100dvh - 155px);
		background-repeat: no-repeat;

		@media(prefers-color-scheme:dark) {
			background-image: url(/study/img/no-embed-dark.png);
		}
	}
}
iframe {
	background-color: white;
	border: none;
	color: black;
	display: block;
	width: 100%;
	height: 100vh; // fallback
	height: 100dvh;
}

</style>
